import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import { DomainInfo } from "@components/severalbrands/utils/services";
import LegalGeneralContainer from "@components/severalbrands/legalPage/containers/legalGeneral";
export default function SeveralBrandsCategoryPage(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <SeveralBrandsWrapper domainInfo={domain as DomainInfo}>
            <LegalGeneralContainer />
        </SeveralBrandsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "category", {
        slug: "legal",
        getDomainMenus: true,
    });
};
